import { useMemo } from 'react';

import { hexColors } from '@ui';

import { MultiColorTracer, type SplitPointConfigItem, type TrackData } from './Tracer';

import type { FrameFirstClubTrack } from '../skeletonUtils';
import type { Segmentation } from '@core';

type ClubPathProps = {
    frame?: number;
    clubTrack: FrameFirstClubTrack;
    segmentation: Segmentation;
    opacity?: number;
};

export function ClubPath({ frame = 0, clubTrack, segmentation, opacity = 1 }: ClubPathProps) {
    const track: TrackData = clubTrack['shaft_end_coordinates'];

    const splitPointConfig: SplitPointConfigItem[] = useMemo(
        () => [
            {
                min: segmentation['P1'],
                max: segmentation['P4'],
                color: hexColors.blue,
                lineWidth: 0.01,
            },
            {
                min: segmentation['P4'] + 1,
                max: segmentation['P7'] - 1,
                color: hexColors.orange,
                lineWidth: 0.01,
            },
            {
                min: segmentation['P7'],
                max: segmentation['P7'] + 1,
                color: hexColors.darkBlue,
                lineWidth: 0.0125,
            },
            {
                min: segmentation['P7'] + 2,
                max: segmentation['P10'],
                color: hexColors.magenta,
                lineWidth: 0.01,
            },
        ],
        [segmentation],
    );

    return <MultiColorTracer frame={frame} track={track} splitPointConfig={splitPointConfig} opacity={opacity} />;
}
